<nb-card>
  <nb-card-header>
    <div class="d-flex justify-content-between align-items-center">
      <span>دسترسی گزارشات</span>
      <input style="min-width: 400px" nbInput status="primary" [(ngModel)]="searchQuery" placeholder="جستجو">
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="row">
      <div class="col-12">
        <nb-card *ngFor="let report of reportsAccessList | searchReport:searchQuery">
          <nb-card-header>
            <div class="d-flex justify-content-between align-items-center">
              <span>{{ report.name }}</span>
              <div class="d-flex gap-1 align-items-center">
                <nb-tag-list>
                  <nb-tag [style.border-color]="output.color" [style.color]="output.color" status="primary" *ngFor="let output of report.tags" appearance="outline"
                          [text]="output.name"></nb-tag>
                </nb-tag-list>
              </div>
            </div>
          </nb-card-header>
          <nb-card-body>
            <div class="row">
              <div class="col-6">
                <nb-card>
                  <nb-card-header>
                    <div class="d-flex justify-content-between">
                      <span>لیست دسترسی‌های کاربران</span>
                      <button (click)="addNewUser(report)" [nbSpinner]="accessLoading && selectedReport === report && selectedAddType === 'user'"
                              [disabled]="accessLoading && selectedReport === report && selectedAddType === 'user'" nbButton status="primary"
                              size="small">افزودن کاربر جدید
                      </button>
                    </div>

                  </nb-card-header>
                  <nb-card-body>
                    <div class="table-responsive overflow-visible">
                      <table class="table table-bordered text-center">
                        <thead>
                        <tr>
                          <th>شناسه‌کاربری</th>
                          <th>ایمیل</th>
                          <th>نام و نام‌خانوادگی</th>
                          <th>حذف دسترسی</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let user of report.userPermissions; let i = index">
                          <td>{{ user.id }}</td>
                          <td><code class="text-white">{{ user.email }}</code></td>
                          <td>{{ user.firstName }} {{ user.lastName }}</td>
                          <td>
                            <button [nbSpinner]="removeAccessLoading && selectedReport === report && selectedRemoveType === 'user'" [disabled]="removeAccessLoading && selectedReport === report && selectedRemoveType === 'user'" (click)="removeAccess(report,user.id,'user')" nbButton ghost><i
                              class="fas fa-times text-danger"></i></button>
                          </td>
                        </tr>
                        <tr *ngIf="report.userPermissions.length === 0">
                          <td class="text-hint text-center pt-3" colspan="19">هیچ رکوردی هنوز ثبت نشده است!</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </nb-card-body>
                </nb-card>
              </div>
              <div class="col-6">
                <nb-card>
                  <nb-card-header>
                    <div class="d-flex justify-content-between">
                      <span>لیست دسترسی‌های سطوح</span>
                      <button (click)="addNewScope(report)" [nbSpinner]="accessLoading && selectedReport === report && selectedAddType === 'scope'"
                              [disabled]="accessLoading && selectedReport === report && selectedAddType === 'scope'" nbButton status="primary"
                              size="small">افزودن سطح جدید
                      </button>
                    </div>

                  </nb-card-header>
                  <nb-card-body>
                    <div class="table-responsive overflow-visible">
                      <table class="table table-bordered text-center">
                        <thead>
                        <tr>
                          <th>شناسه سطح</th>
                          <th>نام</th>
                          <th>حذف دسترسی</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let scope of report.scopePermissions; let i = index">
                          <td>{{ scope.id }}</td>
                          <td>{{ scope.name }}</td>
                          <td>
                            <button [nbSpinner]="removeAccessLoading && selectedReport === report && selectedRemoveType === 'scope'" [disabled]="removeAccessLoading && selectedReport === report && selectedRemoveType === 'scope'"  (click)="removeAccess(report,scope.id,'scope')" nbButton ghost><i
                              class="fas fa-times text-danger"></i></button>
                          </td>
                        </tr>
                        <tr *ngIf="report.scopePermissions.length === 0">
                          <td class="text-hint text-center pt-3" colspan="19">هیچ رکوردی هنوز ثبت نشده است!</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </nb-card-body>
                </nb-card>
              </div>
            </div>
          </nb-card-body>
        </nb-card>
      </div>
    </div>
  </nb-card-body>
</nb-card>

<ng-template #AdminListTemplate let-ref="dialogRef">
  <nb-card style="max-height: 400px;min-width: 500px">
    <nb-card-header>
      <div class="d-flex justify-content-between align-items-center">
        <span>لیست کاربران</span>
        <input nbInput [(ngModel)]="searchUserQuery" placeholder="جستجتو بر اساس ایمیل یا نام و نام خانوادگی">
      </div>
    </nb-card-header>
    <nb-card-body class="py-0">
      <nb-list-item class="cursor-pointer" (click)="addUserPermission(user);ref.close()"
                    *ngFor="let user of users | searchAdminUser: searchUserQuery">
        <nb-user [name]="user.firstName + ' ' + user.lastName" [title]="user.email"></nb-user>
      </nb-list-item>
    </nb-card-body>
  </nb-card>
</ng-template>
<ng-template #ScopeListTemplate let-ref="dialogRef">
  <nb-card style="max-height: 400px;min-width: 500px">
    <nb-card-header>
      <div class="d-flex justify-content-between align-items-center">
        <span>لیست کاربران</span>
        <input nbInput [(ngModel)]="searchScopeQuery" placeholder="جستجتو بر اساس ایمیل یا نام و نام خانوادگی">
      </div>
    </nb-card-header>
    <nb-card-body class="py-0">
      <nb-list-item class="cursor-pointer" (click)="addScopePermission(scope);ref.close()"
                    *ngFor="let scope of scopes | searchScope:searchScopeQuery">
        {{ scope.id }}- {{ scope.name }}
      </nb-list-item>
    </nb-card-body>
  </nb-card>
</ng-template>
